'use strict';

module.exports = {
	name: /[\w]/,
	email: /^[^@]+@[^.@]+\.[^@]+$/,
	message: /[\w]/
};
